export default "__VITE_ASSET__sai$PM5D__"